import React from "react";
import { BaseSvgIcon, createIcon } from "../IconBase";
// GENERATED from custom/src/one_column_layout.svg by scripts/generate-icons.mjs. Do not edit
// by hand — edit the source SVG and regenerate.
const OneColumnLayoutIconGlyph = (props) => (React.createElement(BaseSvgIcon, { ...props },
    React.createElement("rect", { x: "2", y: "2", width: "20", height: "9", rx: "1", fill: "currentColor" }),
    React.createElement("rect", { x: "2", y: "13", width: "20", height: "9", rx: "1", fill: "currentColor" })));
export const OneColumnLayoutIcon = createIcon(OneColumnLayoutIconGlyph, "OneColumnLayoutIcon", "0 0 24 24");
//# sourceMappingURL=OneColumnLayoutIcon.js.map